import { UseQueryResult } from '@tanstack/react-query';
import { BikeleasingV2ConditionDTO } from 'probonio-shared-ui/api';
import { apis, useTenantQuery } from 'probonio-shared-ui/module/api';
import { catchNotFound } from 'probonio-shared-ui/module/error/api-errors';

export function useBikeleasingCondition(): UseQueryResult<BikeleasingV2ConditionDTO | null> {
  return useTenantQuery(
    ['bikeleasingV2', 'condition'],
    tenantId =>
      apis.bikeLeasingV2
        .getCondition({ tenantId })
        .then(res => res.data.condition)
        .catch(err => catchNotFound(err)),
    { retry: false, staleTime: 10 * 60 * 1000 },
  );
}
